module.exports = __webpack_public_path__ + "img/ISO27001-cert-2.0912ca85.jpg";